import React from 'react'

import { ListItemSDUI } from './ListItemSDUI'
import { ListItemSDUIRendererBase } from '../hooks/ListItemSDUIRendererBase'
import type { SDUIComponentProps } from '../interfaces'

interface ListItemSDUIRendererProps {
  sduiComponent: SDUIComponentProps
}

export const ListItemSDUIRenderer: React.FC<ListItemSDUIRendererProps> = ({ sduiComponent }) => (
  <ListItemSDUIRendererBase
    sduiComponent={sduiComponent}
    inlineItems={(sduiComponent.props?.items ?? []) as ListItemData[]}
    Component={ListItemSDUI}
  />
)
